import {
  Autocomplete,
  Button,
  TextField,
  Typography,
  ButtonGroup,
  Tab,
  Tabs,
  DialogActions,
  MenuItem,
  Grid,
  Radio,
  RadioGroup,
  FormControlLabel,
  FormControl,
  FormLabel,
} from "@mui/material";
import { styled } from "@mui/material/styles";
import PropTypes from "prop-types";
import React, { useEffect, useState } from "react";

import { getDocumentoVariables } from "../../../../../containers/smartForms/components/helper";
import { useDocumentTypes } from "../../../../../hooks/documentTypes";
import { useTemplateList } from "../../../../../hooks/useTemplateList";
import { language } from "../../../../../language";
import GenericModal from "../../../../modal-closebtn/index";
import GenericSnackbar from "../../../../snackbar/generic-snackbar";
import { getUniqueDocumentServiceFields } from "../../../../../util/camundaPropertiesPanelUtils";

const FormPadding = styled("div")(({ theme }) => ({
  padding: "1% 1%",
}));

// TAB PANEL
function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <Typography
      component="div"
      role="tabpanel"
      hidden={value !== index}
      id={`wrapped-tabpanel-${index}`}
      aria-labelledby={`wrapped-tab-${index}`}
      {...other}
    >
      {children}
    </Typography>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};

// TAB PROPERTIES
function TabProperties({
  documentTypeList,
  handleChangeDocumentType,
  templateList,
  handleChangeTemplate,
  handleChangeConfigFields,
  handleChangeIsMinuta,
  handleChangeMinuta,
  jsonConfig,
  taskFields,
  businessObject,
}) {
  const documentType = jsonConfig?.documentType || "";
  const template = jsonConfig?.template || "";
  const documentResult = jsonConfig?.documentResult || "";
  const isMinutaString = jsonConfig?.isMinutaString || "";

  const minuta = jsonConfig?.minuta || [];
  let documentVariables = getDocumentoVariables(taskFields) || [];
  documentVariables = documentVariables.concat(
    getUniqueDocumentServiceFields(businessObject),
  );

  documentVariables = documentVariables.filter((value, index, self) => {
    return index === self.findIndex((obj) => obj.id === value.id);
  });

  return (
    <Grid container spacing={5} sx={{ marginY: 3 }}>
      <Grid item size={12}>
        <TextField
          required
          fullWidth
          id="documentResult"
          name="documentResult"
          label={language.id}
          value={documentResult}
          onChange={handleChangeConfigFields}
          variant="outlined"
        />
      </Grid>

      <Grid item size={12}>
        <TextField
          select
          label={language.documentType}
          variant="outlined"
          id="documentType"
          name="documentType"
          inputProps={{
            id: "",
          }}
          value={documentType}
          onChange={handleChangeDocumentType}
          fullWidth
        >
          <MenuItem value="">
            <em></em>
          </MenuItem>
          {documentTypeList &&
            documentTypeList.map((item) => {
              return (
                <MenuItem key={item.id} value={item.id}>
                  {item.name}
                </MenuItem>
              );
            })}
        </TextField>
      </Grid>

      <Grid item size={12}>
        <FormControl component="fieldset">
          <FormLabel component="legend">{language.selectTempalteType}</FormLabel>
          <RadioGroup
            row
            name="isMinutaString"
            value={isMinutaString}
            onChange={(event) => handleChangeIsMinuta(event)}
          >
            <FormControlLabel
              value="template"
              control={<Radio />}
              label={language.template}
            />
            <FormControlLabel
              value="minuta"
              control={<Radio />}
              label="Variável do processo contendo o XSD"
            />
          </RadioGroup>
        </FormControl>
      </Grid>

      {isMinutaString === "template" && (
        <Grid item size={12}>
          <TextField
            select
            label={language.template}
            variant="outlined"
            id="template"
            name="template"
            inputProps={{
              id: "",
            }}
            value={template}
            onChange={handleChangeTemplate}
            fullWidth
          >
            <MenuItem value="">
              <em></em>
            </MenuItem>
            {templateList &&
              templateList.map((item) => {
                return (
                  <MenuItem key={item.id} value={item.id}>
                    {item.name}
                  </MenuItem>
                );
              })}
          </TextField>
        </Grid>
      )}

      {isMinutaString === "minuta" && (
        <Grid item size={12}>
          <Autocomplete
            value={minuta}
            onChange={handleChangeMinuta}
            multiple
            id="minuta-list"
            options={documentVariables}
            getOptionLabel={(fileField) => fileField.id}
            filterSelectedOptions
            getOptionSelected={(option, value) => option.id === value.id}
            renderInput={(params) => (
              <TextField
                {...params}
                variant="outlined"
                required
                fullWidth
                label="Selecione o XSD"
              />
            )}
          />
        </Grid>
      )}
    </Grid>
  );
}

// CUSTOMIZA AS AÇÔES DO MODAL
function OverrideModalActions(props) {
  const { handleSubmit, handleClose } = props;
  return (
    <DialogActions>
      <ButtonGroup>
        <Button
          variant="outlined"
          size="large"
          color="primary"
          onClick={handleClose}
        >
          {language.cancel}
        </Button>
        <Button
          variant="contained"
          size="large"
          color="primary"
          onClick={handleSubmit}
        >
          {language.save}
        </Button>
      </ButtonGroup>
    </DialogActions>
  );
}

const REGISTRAR_DOCUMENT_INITIAL_VALUE = {
  template: null,
  documentType: null,
  documentTitle: "",
  folderTree: [],
  attachments: [],
  metadados: [],
  documentResult: "",

  documentPath: "",

  minutaId: null,
  minuta: [],

  isMinuta: null,
  isMinutaString: "",
};

// Componente

function ModelerModalGerarXml({
  saveGerarXmlConfig, // modeler
  businessObject,
  element,
  extensionElements,
  bpmnFactory,
  FormComponents,
  inputValues,
}) {
  const [state, setState] = useState({
    fullWidth: true,
    maxWidth: "md",
    tabValue: 0,
    folderSelected: [],
    currentFolderSelected: false,
  });

  const [jsonConfig, setJsonConfig] = useState({
    ...REGISTRAR_DOCUMENT_INITIAL_VALUE,
  });
  const [hasConfigError, setHasConfigError] = useState(false);
  const [open, setOpen] = useState(true);

  const { data: documentTypeList } = useDocumentTypes({
    params: {
      isPageable: false,
    },
  });

  const { data: templateList, refetch: fetchTemplateListPaging } =
    useTemplateList({
      enabled: false,
      params: {
        firstResult: 0,
        maxResults: 1000,
        sortBy: "id,asc",
        isPageable: false,
        byDocumentType: jsonConfig?.documentType,
        draft: false,
        enabled: true,
      },
    });

  // EFFECT - preenche o state com os dados do modeler
  useEffect(() => {
    if (inputValues) {
      setJsonConfig({
        folderTree: inputValues?.folderTree,
        documentPath: inputValues?.folderTree?.join("/"),
        documentos: inputValues?.attachments,
        metadados: inputValues?.metadados,
        documentResult: inputValues?.documentResult,
        documentTitle: inputValues?.documentTitle,
        documentType: inputValues?.documentType,
        template: inputValues?.template,
        isMinuta: inputValues?.isMinuta,
        isMinutaString: inputValues?.isMinuta ? "minuta" : "template",
        minutaId: inputValues?.minutaId,
        minuta: inputValues?.minutaId ? [{ id: inputValues?.minutaId }] : [],
      });
    }
  }, [inputValues]);

  useEffect(() => {
    if (!jsonConfig.documentType) return;
    fetchTemplateListPaging();
  }, [jsonConfig.documentType]);

  const validateConfig = (obj) => {
    const erros = [];

    if (!obj.documentResult || obj.documentResult.trim().length <= 0) {
      erros.push(language.documentIdIsRequired);
    }

    if (!obj.documentType) {
      erros.push(language.documentTypeIsRequired);
    }

    if (obj.isMinuta === undefined || obj.isMinuta === null) {
      erros.push(language.templateTypeIsRequired);
    }

    if (!obj.isMinuta && !obj.template) {
      erros.push(language.templateIsRequired);
    }

    if (obj.isMinuta && !obj.minutaId) {
      erros.push(language.draftIsRequired);
    }

    return erros;
  };

  const handleClose = () => {
    setOpen(false);
  };

  //gerencia state das abas
  const handleChangeTab = (event, newValue) => {
    setState((prev) => ({
      ...prev,
      tabValue: newValue,
    }));
  };

  const handleSave = () => {
    const folderTree =
      jsonConfig?.documentPath?.trim().length > 0
        ? jsonConfig?.documentPath?.trim().split("/")
        : [];
    const attachments =
      jsonConfig?.documentos?.map((doc, index) => {
        return {
          variableId: doc.variableId,
          properties: {
            isMainFile: index === 0,
          },
          name: doc.name,
        };
      }) || [];
    const metadados = jsonConfig?.metadados || [];
    const documentResult = jsonConfig?.documentResult;
    const documentTitle = jsonConfig?.documentTitle;
    const documentType = jsonConfig?.documentType;
    const template = jsonConfig?.template;
    const isMinuta = jsonConfig?.isMinuta;
    const minutaId = jsonConfig?.minutaId;

    const inputObject = {
      folderTree,
      attachments,
      metadados,
      documentResult,
      documentTitle,
      documentType,
      template,
      isMinuta,
      minutaId,
    };

    const erros = validateConfig(inputObject);

    if (erros.length > 0) {
      setHasConfigError(erros);
    } else {
      //salvando no modeler
      saveGerarXmlConfig(
        businessObject,
        element,
        extensionElements,
        bpmnFactory,
        inputObject,
      );

      handleClose();
    }
  };

  const handleChangeDocumentType = (event) => {
    const { value } = event.target;
    setJsonConfig((prev) => ({
      ...prev,
      documentType: value,
      template: null,
    }));
  };

  const handleChangeTemplate = (event) => {
    const { value } = event.target;
    setJsonConfig((prev) => ({
      ...prev,
      template: value,
    }));
  };

  const handleChangeConfigFields = (event) => {
    const { name, value } = event.target;
    setJsonConfig((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleChangeIsMinuta = (event) => {
    const { name, value } = event.target;

    setJsonConfig((prev) => ({
      ...prev,
      [name]: value,
      isMinuta: value === "minuta",
    }));
  };

  const handleChangeMinuta = (event, newValue) => {
    // pega o ultimo elemento selecionado
    const value =
      newValue && newValue.length > 0 ? [newValue[newValue.length - 1]] : [];

    setJsonConfig((prev) => ({
      ...prev,
      minuta: value,
      minutaId: value?.[0]?.id || null,
    }));
  };

  const { tabValue } = state;

  return (
    open && (
      <GenericModal
        title={language.configuration}
        handleClose={handleClose}
        size={state.maxWidth}
        bigHeight
        open={true}
        handleSubmit={handleSave}
        btnActionTitle={language.save}
        btnCancelTitle={language.cancel}
        overrideDialogActions={() =>
          OverrideModalActions({
            handleSubmit: handleSave,
            handleClose,
          })
        }
      >
        <Tabs
          value={tabValue}
          indicatorColor="secondary"
          textColor="secondary"
          onChange={handleChangeTab}
        >
          <Tab label={language.properties} />
        </Tabs>

        <FormPadding>
          <TabPanel value={tabValue} index={0}>
            <TabProperties
              businessObject={businessObject}
              taskFields={FormComponents}
              jsonConfig={jsonConfig}
              documentTypeList={documentTypeList?.content || []}
              handleChangeDocumentType={handleChangeDocumentType}
              templateList={(templateList?.content || []).filter(
                (item) =>
                item?.name?.toLowerCase().endsWith(".xsd") ||
                  item?.description?.toLowerCase().endsWith(".xsd"),
              )}
              handleChangeTemplate={handleChangeTemplate}
              handleChangeConfigFields={handleChangeConfigFields}
              handleChangeIsMinuta={handleChangeIsMinuta}
              handleChangeMinuta={handleChangeMinuta}
            />
          </TabPanel>
        </FormPadding>

        {hasConfigError && (
          <GenericSnackbar
            errorWithChildren={true}
            message={
              <div>
                {hasConfigError.map((err, index) => {
                  return <div key={`errorMessage_${index}`}>{err}</div>;
                })}
              </div>
            }
            handleClose={() => setHasConfigError(false)}
            duration={4000}
          />
        )}
      </GenericModal>
    )
  );
}

export default ModelerModalGerarXml;
